import i18n from 'Pods/Shared/I18n'

const KEY_PREFIX = 'subscription_item_page.plans_restructure'

export default function translatePlansRestructure(key, options = {}) {
  return i18n.t(`${KEY_PREFIX}.${key}`, { ns: 'rails', ...options })
}
